module.exports = __webpack_public_path__ + "img/fresca.92083d74.png";